import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column, HorizontalLine } from "@faire/web--source/slate/Layout";
import { LoadingSkeleton } from "@faire/web--source/slate/LoadingSkeleton";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import React, { Fragment } from "react";
export var SDUIFilterablePaginatedSectionFiltersLoadingSkeleton = function() {
    return /*#__PURE__*/ _jsx(Column, {
        children: Array.from({
            length: 5
        }).map(function(_, index) {
            return /*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "3x"
                    }),
                    /*#__PURE__*/ _jsx(LoadingSkeleton, {
                        width: getSpacing(120),
                        height: getSpacing(20)
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "3x"
                    }),
                    /*#__PURE__*/ _jsx(HorizontalLine, {})
                ]
            }, index);
        })
    });
};
